import { get, put } from 'services/api';
import { IUser } from 'interface/user';
import { hjTagging } from 'utils';

declare let gtag: (command: string, value: any) => void;

export const receiveUserProfile = (profile: Object) => ({
  type: 'RECEIVE_USER_PROFILE',
  profile,
});

export const receiveUserProfileError = (error: any) => ({
  type: 'RECEIVE_USER_PROFILE_ERROR',
  error,
});

export const receiveCoursesCount = (count: any) => ({
  type: 'RECEIVE_COURSES_COUNT',
  count,
});

export const cleanUserProfile = () => ({
  type: 'CLEAN_USER_PROFILE',
});

const refreshUserProfileSuccess = () => ({
  type: 'REFRESH_USER_PROFILE_SUCCESS',
});

const refreshUserProfileError = () => ({
  type: 'REFRESH_USER_PROFILE_ERROR',
});

export const fetchUserProfile = () => (dispatch: any, getState: Function) => {
  const state = getState();
  if (state.user.id) {
    return;
  }
  get({ url: '/user/profile' })
    .then(
      (res) => {
        dispatch(receiveUserProfile(res.data.data));
        const userId = res.data.data.id;
        hjTagging(`USER-${userId}`);
        // SET USER ID TO TRACKING IN GOOGLE ANALYTICS ...
        gtag('set', { user_id: userId });
      },
      (err) => dispatch(receiveUserProfileError(err))
    )
    .catch((err) => dispatch(receiveUserProfileError(err)));
};

export const refreshUserProfile = (user: IUser) => async (dispatch: any) => {
  try {
    const response = await put({
      url: '/user/profile',
      data: {
        avatar: '0',
        socketSessionId: localStorage.getItem('socketSessionId'),
        ...user,
      },
    });
    await dispatch({
      type: 'REFRESH_USER_PROFILE',
      user,
    });
    dispatch(refreshUserProfileSuccess());

    return response.data;
  } catch (error) {
    dispatch(refreshUserProfileError());

    throw error;
  }
};

export const turnStudentProducer = (user: IUser) => async (dispatch: any) => {
  const refreshToken = localStorage.getItem('refreshToken');

  try {
    const response = await put({
      url: '/user/turn/producer',
      headers: {
        RefreshToken: refreshToken,
      },
    });
    await dispatch({
      type: 'REFRESH_USER_PROFILE',
      user,
    });
    dispatch(refreshUserProfileSuccess());

    return response.data;
  } catch (error) {
    dispatch(refreshUserProfileError());

    throw error;
  }
};
